/**
 * Brend belgisi — sayt (apps/web/src/components/BrandMark.tsx) bilan bir xil shakl.
 * Lime kvadrat + jo'natma qutisi (skotch bilan) + tezlik chiziqlari = "tez yetkaziladigan jo'natma".
 * Ranglar qat'iy (tema tokenlari emas): belgi light va dark fonda bir xil ko'rinadi.
 */
export function BrandMark({ size, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="16" fill="#c6ff3d" />
      <path d="M7 27h8M5 34h10M9 41h6" stroke="#0b0f14" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M38 12l16 8v20l-16 8-16-8V20z" fill="#0b0f14" />
      <path
        d="M22 20l16 8 16-8M38 28v20"
        fill="none"
        stroke="#c6ff3d"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path
        d="M30 16l16 8v7"
        fill="none"
        stroke="#c6ff3d"
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
